
import XButton from 'vux/src/components/x-button/index.vue'

import {Card, HeadBar} from '@/components';
import {OrderProxy} from '@/http/RequestProxy.class';
import utils from '@/utils/utils';

const orderProxy = new OrderProxy();

export default {
name: 'cancel-order',
components: {
Card,
HeadBar,
XButton,
},
data(){
return {
isShowTextArea: false,
reasonIdx: 0,
cancelText: '',
query: {
cancel_reason: '',
},
};
},
mounted(){
this.query = Object.assign({}, this.query, this.$route.params);
},
methods: {
/** 选择取消订单理由 */
onSelectReason(ev){
let val = ev.target.dataset.val;
let index = ev.target.dataset.index;

this.reasonIdx = index;
if(val != 'other'){
this.query.cancel_reason = val;
this.isShowTextArea = false;
}else{
this.isShowTextArea = true;
}
},

onConfirmCancel(){
if(this.reasonIdx == 6){
if(this.cancelText){
this.query.cancel_reason = this.cancelText;
}else{

this.$vux.toast.show({text: this.$i18n.t('hotel.Please_write_your_reason')});
return ;
}
}else{
if(!this.query.cancel_reason){

this.$vux.toast.show({text: this.$i18n.t('hotel.Please_write_your_reason')});
return ;
}
}

let params = utils.deepCopy(this.query);

delete params.order_status;
this.$vux.loading.show();
orderProxy.cancelOrder(params)
.then(resp => {
if(resp) {
this.$vux.alert.show({
content: resp.msg,
buttonText: this.$i18n.t('hotel.KONW'),
onHide: () => {
this.$router.back();
},
});
}
this.$vux.loading.hide();
});


},
},
}



// WEBPACK FOOTER //
// ./src/views/order/order-cancel.vue